import { ILegalView } from "../../model/LegalView";
import { IOrganisation } from "../../../organisations/model/Organisation";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import { DateFormats } from "../../../core/common/Constants";
import moment from "moment";

export interface TLegalViewPresentationModel extends ILegalView {
  organisationName: string;
  legalViewTypeName: string;
  legalViewType: IDocumentType;
  formattedDate: string;
  summaryTranslation: string;
}

const LegalViewPresentationModel = (
  data: ILegalView,
  legalViewType?: IDocumentType,
  organisation?: IOrganisation,
  summaryTranslation?: string
) => {
  const handler: ProxyHandler<ILegalView> = {
    get: function (target, prop, receiver) {
      const legalViewDate = target.legalViewDate
        ? moment(target.legalViewDate)
        : null;
      switch (prop) {
        case "organisationName":
          return organisation?.name;
        case "legalViewType":
          return legalViewType;
        case "legalViewTypeName":
          return legalViewType?.name;
        case "summaryTranslation":
          return summaryTranslation;
        case "formattedDate":
          return legalViewDate?.format(DateFormats.DATE) || "";
        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "organisationName":
        case "legalViewType":
        case "formattedDate":
        case "legalViewTypeName":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<ILegalView, TLegalViewPresentationModel>(data, handler);
};

export default LegalViewPresentationModel;
